import { batch, connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { getDeliveryByEventName } from '@noths/polaris-client-utils';
import type { Dispatch } from '@reduxjs/toolkit';

import { DeliveryBlock } from 'src/components/organisms/DeliveryBlock/DeliveryBlock';
import type {
  DeliveryBlockDispatchProps,
  DeliveryBlockOnCountryChangeArgs,
  DeliveryBlockStateProps,
} from 'src/components/organisms/DeliveryBlock/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectDecoratedDeliveryOptions,
  selectDeliveryOptions,
  selectDeliveryOptionsForZone,
  selectGroupedCountriesForDropdown,
  selectSelectedCountry,
  selectSelectedZone,
} from 'src/redux/delivery/selectors';
import { actions as deliveryActions } from 'src/redux/delivery/slice';
import { selectProduct, selectProductDeliveryByEvent } from 'src/redux/product/selectors';

const mapStateToProps = (state: ReduxApplicationState): DeliveryBlockStateProps => {
  const product = selectProduct(state);
  const deliveryEvent = selectProductDeliveryByEvent(state);
  const deliveryOptionsForCurrentZone = selectDeliveryOptionsForZone(state);
  const allDeliveryZones = selectDeliveryOptions(state);
  return {
    ...(deliveryEvent
      ? {
          arrivesBy: {
            date: String(deliveryEvent.lastDeliveryBy),
            name: getDeliveryByEventName(deliveryEvent.eventName)?.name,
          },
        }
      : {}),
    groupedCountries: selectGroupedCountriesForDropdown(state),
    deliveryOptions: selectDecoratedDeliveryOptions(state),
    deliveryOptionsForCurrentZone: deliveryOptionsForCurrentZone ?? [],
    hasAnyDeliveryZones: allDeliveryZones.length > 0,
    selectedCountry: `${selectSelectedCountry(state)}|${selectSelectedZone(state)}`,
    partnerName: product.partner.name,
    photoUploadRequired: product.specialFeatures.requiresPhotoUpload || false,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DeliveryBlockDispatchProps => ({
  onCountryChange: (payload: DeliveryBlockOnCountryChangeArgs) => {
    batch(() => {
      dispatch(deliveryActions.setSelectedZone(payload.selectedZone));
      dispatch(deliveryActions.setSelectedCountry(payload));
    });
  },
  onVisible: () => {
    sendGAEvent({
      event: 'custom_event_v2',
      event_name: 'view_content',
      event_details: undefined,
      content_type: 'delivery information',
      item_id: undefined,
    });
  },
});

export const DeliveryBlockContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryBlock);
